module.exports = __webpack_public_path__ + "f00fee816ca5fa9b9fa18ad55da02474.svg";